var generateStyle = function generateStyle() {
  return {
    tags: {
      "float": 'right'
    }
  };
};
export default generateStyle;